import { render, staticRenderFns } from "./Mapping.vue?vue&type=template&id=6ad4eb1e&"
import script from "./Mapping.vue?vue&type=script&lang=js&"
export * from "./Mapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports